import { MediumHeader } from '@narvar/nth-bit-header';
import Paragraph from '@narvar/nth-bit-paragraph';
import React, { FC } from 'react';
import { StatusMessageResponse } from '../../../../server/lib/metro/types';
import { useTranslator } from '../utils/translator';

interface Props {
  response: StatusMessageResponse;
}

const ExceptionPanel: FC<Props> = ({ response }) => {
  const { t } = useTranslator();
  const scheduleDeliveryAnaPromptHeader = t('Delivery to be scheduled');
  const scheduleDeliveryAnaPromptMessage = // This is only the case for metro!
    'A delivery window is not available at this time. Have a question about your delivery? Contact our white glove service partner, Metropolitan Warehouse & Delivery at 866.466.3876.';
  const scheduleDeliveryTnwPromptHeader = t('Delivery scheduling error');
  const scheduleDeliveryTnwPromptMessage = t(
    'An error occured trying to schedule your delivery.',
  );

  let header = '';
  let message = '';

  switch (response.status) {
    case 'ANA': // Only there for metro
      header = scheduleDeliveryAnaPromptHeader;
      message = scheduleDeliveryAnaPromptMessage;
      break;
    case 'TNW':
      header = scheduleDeliveryTnwPromptHeader;
      message = scheduleDeliveryTnwPromptMessage;
      break;
    case 'Failed':
      header = scheduleDeliveryTnwPromptHeader;
      message = response.message;
      break;
    default:
      throw new Error('Unhandled carrier status in the Exception Panel.');
  }

  return (
    <>
      <MediumHeader as="h2">{header}</MediumHeader>
      <Paragraph containerCustomStyle={{ marginBottom: '0' }}>
        {message}
      </Paragraph>
    </>
  );
};

export default ExceptionPanel;
